// useUnsavedChangesWarning.js
import { useEffect } from 'react';

const useUnsavedChangesWarning = (isFormDirty, navigate, blockLink) => {
  useEffect(() => {
    if (isFormDirty) {
      let shouldBlockPopState = true;

      const handleBeforeUnload = (event) => {
        if (isFormDirty) {
          event.preventDefault();
          event.returnValue = '';
        }
      };

      const handlePopState = (event) => {
        if (isFormDirty && shouldBlockPopState) {
          const confirmationMessage = 'Você tem alterações não salvas. Tem certeza de que deseja sair?';
          const confirmed = window.confirm(confirmationMessage);

          if (!confirmed) {
            window.history.pushState(null, '', window.location.href);
          } else {
            shouldBlockPopState = false;

            const rotas = JSON.parse(sessionStorage.getItem('rotas')) || [];
            const recentRoutes = rotas.slice(-3);

            const isSequential = recentRoutes.length === 3 &&
              /^\/pesquisa-de-preco\/\d+$/.test(recentRoutes[0]) &&
              /^\/pesquisa-de-preco\/\d+\/(nova-pesquisa|editar\/\d+)$/.test(recentRoutes[1]) &&
              /^\/pesquisa-de-preco\/\d+$/.test(recentRoutes[2]);

            const lastValidRoute = rotas
              .slice()
              .reverse()
              .find(route => !/^\/pesquisa-de-preco\/\d+(\/nova-pesquisa|\/editar\/\d+)?$/.test(route));

            if (lastValidRoute) {
              navigate(lastValidRoute);
            }
          }
        } else {
          shouldBlockPopState = true;
        }
      };

      const handleLinkClick = (event) => {
        if (isFormDirty) {
          const confirmationMessage = 'Você tem alterações não salvas. Tem certeza de que deseja sair?';
          const confirmed = window.confirm(confirmationMessage);

          if (!confirmed) {
            event.preventDefault();
          }
        }
      };

      const links = document.querySelectorAll('a');

      links.forEach(link => {
        if(blockLink && link.text !== blockLink){
          link.addEventListener('click', handleLinkClick);
        }
      });

      window.history.pushState(null, '', window.location.href);

      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('popstate', handlePopState);

      return () => {
        links.forEach(link => {
          link.removeEventListener('click', handleLinkClick);
        });

        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [isFormDirty, navigate]);
};

export default useUnsavedChangesWarning;
